module.exports = __webpack_public_path__ + "img/slogan.cf1dac90.png";